import styled from "@emotion/styled";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { sharedPostActionButtonStyles } from "../../../../Components/Post/PostActions/PostActionButtons.styles";
import { Typography } from "@mui/material";

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
    "&.MuiToggleButtonGroup-root": {
        ...sharedPostActionButtonStyles,
        gap: "0",
        padding: "0 4px",
        alignItems: "center",
    },
}));

export const ModalReactionsListContainer = styled(ToggleButtonGroup)({
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    margin: "0 12px",
    paddingBottom: "8px",
});

export const ModalReactionsListTooltipContainer = styled(ToggleButtonGroup)({
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    "button:last-of-type": {
        marginRight: 0,
    },
    margin: "0 12px",
    paddingBottom: "8px",
});

export const ReactionsListTooltipContainer = styled(ToggleButtonGroup)({
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    marginBottom: "0",
    "button:last-of-type": {
        marginRight: 0,
    },
});

export const ReactionCountTypography = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "fullWidth",
})<{ fullWidth?: boolean }>((props) => ({
    // ToggleButtonGroup is a parent of this element and unconditionally passes fullWidth param to this component. This causes error in console
    fontSize: "14px",
    marginLeft: "8px",
}));
